import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649zm9.99.006l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649zm9.99.006l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649zm9.99.006l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649zm9.99.006l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 12.193a2.97 2.97 0 00-3 .002L25 21.133v-6.352a2.976 2.976 0 00-1.502-2.6 2.977 2.977 0 00-2.998.002L4.534 21.401a2.973 2.973 0 00-1.5 2.6c0 1.084.564 2.054 1.5 2.594L20.5 35.813c.468.27.984.408 1.502.408.514 0 1.028-.138 1.498-.406a2.975 2.975 0 001.5-2.6v-6.352l15.48 8.938c.468.27.984.408 1.502.408.514 0 1.03-.138 1.498-.406a2.971 2.971 0 001.5-2.6v-18.41c0-1.084-.56-2.058-1.5-2.6z",
    clipRule: "evenodd"
  }))
};
export var RewindFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});